// extracted by css-extract-rspack-plugin
export default {"root":"QjzjT","title":"nc9Bx","overlay":"bTdeY","content":"ND0UY","header":"KcYkN","ModalCloseButton":"nFivu","footer":"e208T","centeredHeading":"axplB","body":"_fGFL"};